import { type FC, useMemo } from "react";
import { FormControl, FormLabel, FormHelperText } from "@/components/essentials/form-control";
import { Input } from "@/components/essentials/input";
import { useFormContext } from "react-hook-form";
import isEmail from "validator/lib/isEmail";
import { emailFormHelperTextTestId, emailFormInputTestId, emailFormLabelTestId } from "./const";
import get from "just-safe-get";

export interface EmailFormProps {
  emailField?: string;
  required?: boolean;
}

export const EmailForm: FC<EmailFormProps> = ({ emailField = "email", required = true }) => {
  const {
    register,
    formState: { errors, dirtyFields },
  } = useFormContext();

  const emailRegister = useMemo(
    () =>
      register(emailField, {
        required,
        validate: (value) => {
          if (!required) {
            return true;
          }
          return isEmail(value);
        },
      }),
    [register, emailField, required],
  );
  return (
    <FormControl
      id={emailField}
      isRequired={required}
      isDirty={get(dirtyFields, emailField) !== undefined}
      isInvalid={get(errors, emailField) !== undefined}
    >
      <FormLabel data-testid={emailFormLabelTestId + "-" + emailField} htmlFor={emailField}>
        メールアドレス
      </FormLabel>
      <Input
        data-testid={emailFormInputTestId + "-" + emailField}
        type="email"
        autoComplete="email"
        size="md"
        placeholder="example@torana.co.jp"
        {...emailRegister}
      />
      <FormHelperText data-testid={emailFormHelperTextTestId + "-" + emailField} testIdSuffix={"-" + emailField}>
        有効なメールアドレスが入力されている
      </FormHelperText>
    </FormControl>
  );
};
